<div #pages class="pages">
  <div #page *ngFor="let pageNumber of pageNumbers" class="page" [attr.page]="pageNumber"></div>
</div>
